import { IConversationRunContainer } from './ConversationRunContainer';
import { ScreenshotRequestContainer } from './ScreenshotRequestContainer';
import { TextContainer } from './TextContainer';
import { UnknownContainer } from './UnknownContainer';

export interface IContainerFactory {
    createContainer(id: string, type: string, data: unknown): IConversationRunContainer;
}
export class ContainerFactory implements IContainerFactory {
    createContainer(id: string, type: string, data: unknown): IConversationRunContainer {
        let container: IConversationRunContainer;
        switch (type) {
            case 'text':
                container = new TextContainer(id, data as string);
                break;
            case 'screenshot_request':
                container = new ScreenshotRequestContainer(id, data as any);

                break;
            default:
                container = new UnknownContainer(id, data);
                break;
        }

        return container;
    }
}
